import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=dfec04ea&scoped=true&"
import script from "./TransferDialog.vue?vue&type=script&lang=js&"
export * from "./TransferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfec04ea",
  null
  
)

export default component.exports